import { useAuth } from "@/context/auth-context";
import { useState } from "react";

type LoginFormProps = {
	mobile: string;
	setMobile: (val: string) => void;
	password: string;
	setPassword: (val: string) => void;
	onSwitchMode: (mode: "login" | "register" | "otp") => void;
	onClose: any;
};

export function LoginForm({
	mobile,
	setMobile,
	password,
	setPassword,
	onSwitchMode,
	onClose,
}: LoginFormProps) {
	const { refreshUser } = useAuth();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const handleLogin = async () => {
		setLoading(true);

		try {
			const res = await fetch("/api/login", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ mobile, password }),
			});

			if (res.ok) {
				await refreshUser();
				onClose();
			} else if (res.status === 403) {
				setError("حساب کاربری شما غیرفعال شده است");
			} else {
				setError("شماره تلفن یا رمزعبور اشتباه است");
			}
		} catch (error) {
			console.error("Login failed:", error);
			setError("خطایی در ارتباط با سرور رخ داده است");
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="w-full flex flex-col gap-2 text-[18px]">
			<label htmlFor="call">شماره تماس</label>
			<input
				dir="ltr"
				id="call"
				type="tel"
				placeholder="09123456789"
				className="w-full p-3 mb-4 bg-gray-600 border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-pink text-left"
				value={mobile}
				onChange={(e) => {
					const val = e.target.value;
					const cleaned = val.replace(/[^\d+]/g, "");
					const limited = cleaned.startsWith("+")
						? cleaned.slice(0, 13)
						: cleaned.slice(0, 11);

					setMobile(limited);
				}}
				inputMode="tel"
				pattern="^09[0-9]{9}$"
				maxLength={11}
				title="Enter an Iranian mobile number like 09123456789"
			/>

			<label htmlFor="password">رمز عبور</label>
			<input
				dir="ltr"
				id="password"
				type="password"
				placeholder="Password"
				className="w-full p-3 mb-4 bg-gray-600 border border-gray-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-custom-pink text-left"
				value={password}
				onChange={(e) => setPassword(e.target.value)}
			/>

			<div className="flex w-full justify-between text-[15px] text-white mb-4">
				<button
					className="opacity-70 hover:opacity-100"
					onClick={() => onSwitchMode("register")}
				>
					هنوز ثبت نام نکردم
				</button>
				<button className="opacity-70 hover:opacity-100">
					فراموشی رمز عبور
				</button>
			</div>

			<button
				type="submit"
				onClick={handleLogin}
				disabled={loading}
				className="text-black text-[20px] font-normal relative hover:opacity-70 m-auto disabled:opacity-50"
				style={{
					backgroundImage: "url(/authentication-button.png)",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					width: "180px",
					height: "50px",
				}}
			>
				{loading ? "در حال ورود..." : "ورود"}
			</button>

			{error && <p className="text-red-400 text-center mt-2">{error}</p>}
		</div>
	);
}
